module.exports = __webpack_public_path__ + "img/w3_delivery_black.7f1d5e8c.png";